module.exports = __webpack_public_path__ + "static/images/47fed8cbff39e0df3c10c180426f81e4.png";